export default "__VITE_ASSET__C9Pl5PZW__"